import { type FC } from 'react';

interface VoiceAudioElementProps {
  audioRef: React.RefObject<HTMLAudioElement | null>;
  src: string | null;
  onPlay: () => void;
  onPause: () => void;
  onEnded: () => void;
  onTimeUpdate: (e: React.SyntheticEvent<HTMLAudioElement>) => void;
}

export const VoiceAudioElement: FC<VoiceAudioElementProps> = ({
  audioRef,
  src,
  onPlay,
  onPause,
  onEnded,
  onTimeUpdate,
}) => (
  <audio
    ref={audioRef as React.RefObject<HTMLAudioElement>}
    src={src ?? undefined}
    preload="auto"
    style={{ display: 'none' }}
    onPlay={onPlay}
    onPause={onPause}
    onEnded={onEnded}
    onTimeUpdate={onTimeUpdate}
  />
);
